import React from "react";

function TextPrimary(props) {
  return (
    <p className="my-5 text-blue report-sub-header">{props.text}</p>
  );
}

export default TextPrimary;
